import { render } from "./HiddenInputFields.vue?vue&type=template&id=fa8b5660"
import script from "./HiddenInputFields.vue?vue&type=script&lang=js"
export * from "./HiddenInputFields.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__